import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { 
  SavedCalculator, 
  CreateSavedCalculatorDto, 
  UpdateSavedCalculatorDto,
  CalculatorType 
} from '../models/saved-calculator.interface';

@Injectable({
  providedIn: 'root'
})
export class SavedCalculatorService {
  private apiService = inject(ApiService);

  /**
   * Ottiene tutti i calcolatori salvati dall'utente corrente
   */
  getUserCalculators(): Observable<SavedCalculator[]> {
    return this.apiService.get<SavedCalculator[]>('/calculator');
  }

  /**
   * Ottiene un calcolatore salvato specifico per ID
   */
  getCalculatorById(calculatorId: string): Observable<SavedCalculator> {
    return this.apiService.get<SavedCalculator>(`/calculators/${calculatorId}`);
  }

  /**
   * Ottiene tutti i calcolatori salvati di un tipo specifico
   */
  getCalculatorsByType(type: CalculatorType): Observable<SavedCalculator[]> {
    return this.apiService.get<SavedCalculator[]>(`/calculators/type/${type}`);
  }

  /**
   * Crea un nuovo calcolatore salvato
   */
  createCalculator(createDto: CreateSavedCalculatorDto): Observable<SavedCalculator> {
    return this.apiService.post<SavedCalculator>('/calculator', createDto);
  }

  /**
   * Aggiorna un calcolatore salvato esistente
   */
  updateCalculator(calculatorId: string, updateDto: UpdateSavedCalculatorDto): Observable<SavedCalculator> {
    return this.apiService.patch<SavedCalculator>(`/calculators/${calculatorId}`, updateDto);
  }

  /**
   * Elimina un calcolatore salvato
   */
  deleteCalculator(calculatorId: string): Observable<void> {
    return this.apiService.delete<void>(`/calculator/${calculatorId}`);
  }

  /**
   * Cerca calcolatori salvati per nome
   */
  searchCalculators(query: string): Observable<SavedCalculator[]> {
    const params = new URLSearchParams({
      q: query
    });
    
    return this.apiService.get<SavedCalculator[]>(`/calculators/search?${params.toString()}`);
  }

  /**
   * Ottiene le statistiche sui calcolatori salvati dell'utente
   */
  getCalculatorStats(): Observable<{
    total: number;
    byType: Record<CalculatorType, number>;
  }> {
    return this.apiService.get<{
      total: number;
      byType: Record<CalculatorType, number>;
    }>('/calculators/stats');
  }
}
